import type { FaireProductEntity } from "../../entity_types/product";

export const p_awa23m9fjm: FaireProductEntity = {
  token: "p_awa23m9fjm",
  type: "product",
  name: "16oz Raw Blueberry Creamy Honey",
  brandToken: "b_2hhbtdht4d",
  brandName: "The Beekeeper's Daughter",
  imageUrl:
    "https://cdn.faire.com/fastly/72f4319e1560a34f7f9bcf736309efb809851214b3bd9bec06477201a0c9b74c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/32a4e7ec91c0e4fde4e3aa752f55469d7f11401c0fd2b0ec973fe55639e02b72.jpeg",
    "https://cdn.faire.com/fastly/41b70e0fc30ad6ff818a30c397c6a07757f9dae3872caaf9ce0abd8163d718a3.jpeg",
    "https://cdn.faire.com/fastly/9b0f6caf0f53c3f9773c8348a26ad7d1f8df8bed8a71d4714d68799febe98758.jpeg",
  ],
  priceDollars: 11.78,
  description:
    "Our Raw Creamy Blueberry Honey is the perfect thick smooth texture for spreading on toast, bagels, or simply melting in to tea. Handcrafted with wildflower honey and blueberries added in. Our creamed honey also come in 3 other flavors - Apricot, Wildflower, and Cinnamon.",
  tags: [],
  msrpDollars: 22.16,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:14.366Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
